export {default} from './FormattedNumber';
export {default as InlineFormattedNumber} from './InlineFormattedNumber';
